import { useCallback } from 'react'
import { Alert } from '@mui/material'
import { useTranslate, BooleanInput, Form, useNotify, useUpdate } from 'react-admin'
import { PRODUCT_REVIEWS_FIELDS } from '../../../providers/localization/constant'
import { UpdateStatusButtonProps } from './type'

export const UpdateStatusButton: React.FC<UpdateStatusButtonProps> = ({ record }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const onError = useCallback(
    ({
      response: {
        data: { message },
      },
    }): void => {
      notify(
        <Alert severity='error' key={1}>
          Error! {message}
        </Alert>,
      )
    },
    [notify],
  )
  const onSuccess = useCallback((): void => {
    const notifyMsg = `${PRODUCT_REVIEWS_FIELDS}.is_active.choices.${
      !record.is_active ? 'active' : 'inActive'
    }`
    notify(
      <Alert severity='success' key={0}>
        {translate(notifyMsg)}รีวิวนี้แล้ว
      </Alert>,
    )
  }, [notify, record.is_active, translate])

  const [update, { isLoading }] = useUpdate(
    'products-reviews',
    {
      id: record.id,
      data: { is_active: !record.is_active },
      previousData: record,
    },
    { onError, onSuccess },
  )

  return (
    <Form>
      <BooleanInput
        source='is_active'
        label={`${PRODUCT_REVIEWS_FIELDS}.is_active.label`}
        onChange={async (e): Promise<void> => {
          e.stopPropagation()
          await update()
        }}
        disabled={isLoading}
      />
    </Form>
  )
}
